import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { BookingTravellerAbstractComponent } from "./booking-traveller-abstract.component";
import { LabelModule } from "libraries/service/label/label.module";
import { TravellerDataTranslationModule } from "libraries/service/traveller-data-translation/traveller-data-translation.module";
import { DatePipeModule } from "libraries/date/date.module";


@NgModule({
    imports: [
        CommonModule,
        TravellerDataTranslationModule,
        DatePipeModule,
        LabelModule,
    ],
    exports: [
        BookingTravellerAbstractComponent,
    ],
    declarations: [
        BookingTravellerAbstractComponent
    ],
    providers: [],
})
export class BookingTravellerAbstractModule {
}
